import { Checkbox } from "@mui/material";
import React from "react";

const CheckBox = React.forwardRef(({ className = "", ariaLabel, ariaLabelledBy, inputProps = {}, ...props }, ref) => {
  const mergedInputProps = {
    ...(ariaLabel ? { "aria-label": ariaLabel } : {}),
    ...(ariaLabelledBy ? { "aria-labelledby": ariaLabelledBy } : {}),
    ...inputProps,
  };
  return (
    <Checkbox
      ref={ref}
      className={`custom-checkbox ${className}`}
      disableRipple
      inputProps={mergedInputProps}
      {...props}
    />
  );
});

export default CheckBox;
